import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const TimerTrackerIcon = ({ fill = "currentColor", ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.75 1.5C9.198 1.5 8.75 1.948 8.75 2.5C8.75 3.052 9.198 3.5 9.75 3.5H13.75C14.302 3.5 14.75 3.052 14.75 2.5C14.75 1.948 14.302 1.5 13.75 1.5H9.75ZM18.7441 3.70508C18.4891 3.72595 18.241 3.84564 18.0625 4.05664C17.7055 4.47764 17.7587 5.1088 18.1797 5.4668L19.6035 6.67383C20.0245 7.03083 20.6557 6.97764 21.0137 6.55664C21.3707 6.13564 21.3175 5.50448 20.8965 5.14648L19.4727 3.93945C19.2622 3.76095 18.9991 3.6842 18.7441 3.70508ZM11.75 4.5C6.788 4.5 2.75 8.538 2.75 13.5C2.75 18.462 6.788 22.5 11.75 22.5C16.712 22.5 20.75 18.462 20.75 13.5C20.75 8.538 16.712 4.5 11.75 4.5ZM11.75 7.5C12.302 7.5 12.75 7.948 12.75 8.5V13.5C12.75 14.052 12.302 14.5 11.75 14.5C11.198 14.5 10.75 14.052 10.75 13.5V8.5C10.75 7.948 11.198 7.5 11.75 7.5Z",
      fill
    }
  ) });
};
export {
  TimerTrackerIcon
};
